// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Cart: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 28 26"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M1.167 0H0v2.437h3.699L6.631 18.51l.18.99H24.888v-2.438H8.745l-.442-2.437H24.11l3.889-13H5.93L5.815.99 5.634 0H1.167zm7.389 26c.833 0 1.603-.465 2.02-1.219a2.532 2.532 0 000-2.437c-.417-.754-1.187-1.219-2.02-1.219-.834 0-1.604.465-2.021 1.219a2.532 2.532 0 000 2.437C6.952 25.535 7.722 26 8.555 26zm16.333-2.438a2.46 2.46 0 00-1.167-2.11 2.247 2.247 0 00-2.333 0 2.46 2.46 0 00-1.167 2.11c0 .871.445 1.676 1.167 2.111a2.247 2.247 0 002.333 0 2.46 2.46 0 001.167-2.11z" />
        </svg>
    );
};

export default React.memo(Cart);
